import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { BrowserModule } from "@angular/platform-browser";
import { WebcamModule } from "ngx-webcam";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { ImageCropperModule } from "ngx-image-cropper";

import { AppSharedModule } from "../../shared/app-shared.module";
import { IDStationRoutes } from "./IDStation-routes";
import { IDStationComponent } from "./index";

import { PhotoStationComponent } from "./photostation/photostation.component";
import { PrintComponent } from "./photostation/print/print.component";

import { PersonSelectorModule } from "../personselector/personselector.module";

import { DataService_photostation } from "./photostation/shared/data.service";

import { ColorPickerModule } from 'ngx-color-picker';

@NgModule({
	declarations: [IDStationComponent, PhotoStationComponent, PrintComponent],
	imports: [
		BrowserModule,
		WebcamModule,
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		MatSlideToggleModule,
		RouterModule,
		PersonSelectorModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		RadioButtonModule,
		ImageCropperModule,
		ColorPickerModule
	],
	providers: [ConfirmationService, DataService_photostation],
})
export class IDStationModule {}
